(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lotus-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ppd-timed-offer')) {
    class PpdTimedOffer extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        window.addEventListener('pageshow', () => this.refresh(), options);
        document.addEventListener('visibilitychange', () => this.refresh(), options);
        this.refresh();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
      }
      refresh() {
        clearTimeout(this.timer);
        const offer = this.querySelector('[data-ppd-offer]');
        const fallback = this.querySelector('[data-ppd-fallback]');
        const endsAt = Date.parse(this.dataset.expiresAt);
        const remaining = endsAt - Date.now();
        const active = Boolean(offer) && Number.isFinite(endsAt) && remaining > 0;
        if (offer) offer.hidden = !active;
        if (fallback) fallback.hidden = active;
        if (active) this.timer = setTimeout(() => this.refresh(), Math.min(remaining, 3600000));
      }
    }
    customElements.define('ppd-timed-offer', PpdTimedOffer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
